import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'next/link';
import Icon from '../Icon';
import GlossaryText from '../GlossaryText';
import styles from './ManualPagination.module.scss';

const ManualPagination = ({ prev = null, next = null }) => {
    if (!prev?.href && !next?.href) {
        return null;
    }

    return (
        <nav className={styles['ManualPagination']} aria-label="Chapter">
            {!!prev?.href && (
                <Link
                    href={prev.href}
                    className={classNames(
                        styles['ManualPagination__Link'],
                        styles['ManualPagination__Link--Prev']
                    )}>
                    <span
                        className={classNames(
                            styles['ManualPagination__Icon'],
                            styles['ManualPagination__Icon--Prev']
                        )}>
                        <Icon
                            type="chevronThinRight"
                            modifiers={['ManualPagination']}
                        />
                    </span>
                    <span className={styles['ManualPagination__Text']}>
                        <span className={styles['ManualPagination__Label']}>
                            Previous
                        </span>
                        <span className={styles['ManualPagination__Title']}>
                            <GlossaryText text={prev.title} />
                        </span>
                    </span>
                </Link>
            )}

            {!!next?.href && (
                <Link
                    href={next.href}
                    className={classNames(
                        styles['ManualPagination__Link'],
                        styles['ManualPagination__Link--Next']
                    )}>
                    <span className={styles['ManualPagination__Text']}>
                        <span className={styles['ManualPagination__Label']}>
                            Next
                        </span>
                        <span className={styles['ManualPagination__Title']}>
                            <GlossaryText text={next.title} />
                        </span>
                    </span>
                    <span className={styles['ManualPagination__Icon']}>
                        <Icon
                            type="chevronThinRight"
                            modifiers={['ManualPagination']}
                        />
                    </span>
                </Link>
            )}
        </nav>
    );
};

const chapterShape = PropTypes.shape({
    title: PropTypes.string,
    href: PropTypes.string,
});

ManualPagination.propTypes = {
    prev: chapterShape,
    next: chapterShape,
};

export default ManualPagination;
